
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/schedule",
      function () {
        return require("private-next-pages/sports/ipl/schedule/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/schedule"])
      });
    }
  